import Permission from "../Permission/Permission";

export default [
     // {
     //      path: '/emergency-response-plan',
     //      name: 'EmergencyResponsePlan',
     //      component: () => import("@/views/Page/EmergencyResponsePlan/EmergencyResponsePlan.vue"),
     //       meta: {
     //           title: 'EmergencyResponsePlan',
     //      },
     // },
     {
          path: '/emergency-response-plan-details/:id',
          name: 'EmergencyResponsePlanDetails',
          component: () => import("@/views/Page/EmergencyResponsePlan/EmergencyResponsePlanDetails.vue"),
           meta: {
               title: 'EmergencyResponsePlanDetails',
               permission: 'EmergencyResponsePlan.show',
          },
     }
];